<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween searchText="查询" @search="onSearch">
      <y-query-item>
        <k-input v-model="para.saleBatchNo" placeholder="请输入我方批次号" clearable></k-input>
      </y-query-item>
      <y-query-item>
        <k-input v-model="para.goodsCodeSale" placeholder="请输入商品货号" clearable></k-input>
      </y-query-item>
      <y-query-item>
        <k-input v-model="para.batchNo" placeholder="请输入三方批次号" clearable></k-input>
      </y-query-item>
      <y-query-item slot="append">
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="arrDataList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()">
    </k-table>
    <k-pagination :total="total" v-if="arrDataList && arrDataList.length > 0" :current-page.sync="para.pageCurrent"
      :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>

<script>
  /**
   * @name: 
   * @description: 备案信息管理
   * @author: zhaoliubin@yuouhui.com
   * @create: 2020-09-11 09:51:40
   * @update: 2020-09-11 09:51:40
   */
  export default {
    components: {
    },
    props: {
    },
    computed: {
    },
    watch: {
    },
    data() {
      return {
        para: {
          pageCurrent: 1,
          pageSize: 15,
          saleBatchNo: '',
          goodsCodeSale: '',
          batchNo: '',
        },
        total: 0,
        arrDataList: [],
        isLoading: false,
      };
    },
    methods: {
      initColumns() {
        return [
          {
            name: '我方批次号',
            field: 'saleBatchNo',
            style: {
              width: 150
            }
          },
          {
            name: '三方批次号',
            field: 'batchNo',
            style: {
              width: 150
            }
          },
          {
            name: '商品货号',
            field: 'goodsCodeSale'
          },
          {
            name: '物料编码',
            field: 'baseDataCode',
          },
          {
            name: '法定折算数量',
            field: 'convertQuantity'
          },
          {
            name: '法定折算单位',
            field: 'convertUnit'
          },
          {
            name: 'HS Code',
            field: 'hsCode'
          }
        ];
      },
      initPageData() {
        let para = this.para;
        this.$fetch({
          api: '/nestle-supply-back-server/wr/customs_record_list',
          para
        }).then(res => {
          this.arrDataList = res.pageList;
          this.total = res.total;
        });
      },
      onChangePageIndex(p) {
        this.para.pageCurrent = p;
        this.initPageData();
      },
      onSearch() {
        this.para.pageCurrent = 1;
        this.initPageData();
      },
      onReset() {
        this.para = this.$options.data().para;
        this.initPageData();
      },
    },
    created() {
      this.initPageData();
    }
  };
</script>

<style lang="postcss" module="css">
</style>